<section class="main-section" style="padding:54px">
  <div class="row">
    <div class="col">
      <div class="invoice-title">
        <h2 class="ml-2">Delivery Challan</h2><h2 class="float-right">Order # 12345</h2>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-6">
          <address class="ml-2">
            <strong>From:</strong><br>
            John Smith<br>
            1234 Main, Apt. 4B<br>
            Springfield, ST 54321
          </address>
        </div>
        <div class="col-md-6 text-right">
          <address>
            <strong>Ship To:</strong><br>
            Manikanta<br>
            1234 Main, Apt. 4B<br>
            Manikonda, ST 54321
          </address>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <address class="ml-2">
            <strong>Payment Method:</strong><br>
            Visa ending **** 4242<br>
            jsmith&#64;email.com
          </address>
        </div>
        <div class="col-md-6 text-right">
          <address>
            <strong>Order Date:</strong><br>
            March 7, 2014<br><br>
          </address>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="panel panel-default">
        <div class="panel-heading">
          <h2 class="panel-title"><strong>Order summary</strong></h2>
        </div>
        <div class="panel-body">
          <div class="table-responsive">
            <table class="table table-condensed">
              <thead>
              <tr>
                <td><strong>Item</strong></td>
                <td class="text-center"><strong>Price</strong></td>
                <td class="text-center"><strong>Quantity</strong></td>
                <td class="text-right"><strong>Totals</strong></td>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>BS-200</td>
                <td class="text-center">$10.99</td>
                <td class="text-center">1</td>
                <td class="text-right">$10.99</td>
              </tr>
              <tr>
                <td>BS-400</td>
                <td class="text-center">$20.00</td>
                <td class="text-center">3</td>
                <td class="text-right">$60.00</td>
              </tr>
              <tr>
                <td>BS-1000</td>
                <td class="text-center">$600.00</td>
                <td class="text-center">1</td>
                <td class="text-right">$600.00</td>
              </tr>
              <tr>
                <td class="thick-line"></td>
                <td class="thick-line"></td>
                <td class="thick-line text-center"><strong>Subtotal</strong></td>
                <td class="thick-line text-right">$670.99</td>
              </tr>
              <tr>
                <td class="no-line"></td>
                <td class="no-line"></td>
                <td class="no-line text-center"><strong>Shipping</strong></td>
                <td class="no-line text-right">$15</td>
              </tr>
              <tr>
                <td class="no-line"></td>
                <td class="no-line"></td>
                <td class="no-line text-center"><strong>Total</strong></td>
                <td class="no-line text-right">$685.99</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
